import {FACEBOOK_ICONS} from './_icons'
import {PATH} from "../../../const/path";

export const FACEBOOK_CONSTANTS = {

  productInfo: {
    inventoryType: [
      {
        id: 1,
        name: 'Nhập tên hàng hóa',
        tooltip: (
          <ul style={{paddingLeft: 12}}>
            <li style={{marginBottom: 8, listStyleType: 'disc'}}>
              Bạn sẽ tự nhập tên hàng hóa và số lượng của hàng hóa, evoshop đề
              xuất bạn nên dùng cú pháp nội dung hàng hóa là:
            </li>
            <li style={{marginBottom: 8}}>
              Tên sản phẩm | Số lượng sản phẩm
            </li>
            <li style={{listStyleType: 'disc'}}>Ví dụ: Áo dài tay | 2</li>
          </ul>
        ),
        value: 'manual',
      },
      {
        id: 2,
        name: 'Sử dụng tên sản phẩm có sẵn',
        tooltip: (
          <ul style={{paddingLeft: 12}}>
            <li style={{marginBottom: 8, listStyleType: 'disc'}}>
              Bạn sẽ chọn và sử dụng tên của các sản phẩm mà bạn đã tạo ở phần
              Quản lý sản phẩm trên hệ thống.
            </li>
            <li style={{listStyleType: 'disc'}}>
              Lưu ý: Thao tác này chỉ sử dụng tên sản phẩm, không trừ tồn kho
              khi bán sản phẩm.
            </li>
          </ul>
        ),
        value: 'auto',
      },
    ],
    withInventoryPriceType: [
      {name: 'Giá bán lẻ', value: 1},
      {name: 'Giá bán sỉ', value: 2},
    ],
  },
  shippingInfo: {
    1: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
        {value: 3, label: 'sender_pay_end_month', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'not_allowing_view', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      partsign: false,
      packageQuantity: 1,
      exchange_goods: false,
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
    2: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
      ],
      transport: [
        {value: '', label: 'Mặc định', checked: true},
        {value: 'road', label: 'Đường bộ', checked: false},
        {value: 'fly', label: 'Đường hàng không', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      pick_date: null,
      pick_shift: [
        {value: 1, label: 'Buổi sáng', checked: false},
        {value: 2, label: 'Buổi chiều', checked: false},
        {value: 3, label: 'Buổi tối', checked: false},
      ],
      cargoInsurrance: {
        value: '',
        active: true,
      },
    },
    3: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'Không cho khách xem hàng', checked: false},
        {value: 3, label: 'Cho thử hàng', checked: false},
      ],
      cargoInsurrance: {
        active: false,
        value: '',
      },
      lengh: 1,
      width: 2,
      height: 3,
    },
    4: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
    5: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
        {value: 3, label: 'sender_pay_end_month', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'Không cho khách xem hàng', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      partsign: false,
      packageQuantity: 1,
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
    6: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'Không cho khách xem hàng', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
    7: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
        {value: 3, label: 'sender_pay_end_month', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'Không cho khách xem hàng', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      partsign: false,
      packageQuantity: 1,
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
    8: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
        {value: 3, label: 'sender_pay_end_month', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'Không cho khách xem hàng', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      partsign: false,
      packageQuantity: 1,
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
    9: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
        {value: 3, label: 'sender_pay_end_month', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'Không cho khách xem hàng', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      partsign: false,
      packageQuantity: 1,
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
    10: {
      payer: [
        {value: 1, label: 'geter_pay', checked: true},
        {value: 2, label: 'sender_pay', checked: false},
        {value: 3, label: 'sender_pay_end_month', checked: false},
      ],
      request: [
        {value: 1, label: 'show_goods_to_customer', checked: true},
        {value: 2, label: 'Không cho khách xem hàng', checked: false},
      ],
      request_goods: [
        {value: 1, label: 'pickup_at_home', checked: true},
        {value: 6, label: 'send_at_post_office', checked: false},
      ],
      partsign: false,
      packageQuantity: 1,
      cargoInsurrance: {
        active: false,
        value: '',
      },
    },
  },
  generalSidebarList: [
    {
      id: 1,
      name: 'facebookManagement_customerLabel',
      href: '/facebook/conversation-stickers',
      icon: FACEBOOK_ICONS.label,
    },
    {
      id: 2,
      name: 'facebookManagement_feedbackTemplate',
      href: '/facebook/response-content-scripts',
      icon: FACEBOOK_ICONS.response,
    },
    {
      id: 3,
      name: 'facebookManagement_autoHideComment',
      href: '/facebook/hide-auto-comments',
      icon: FACEBOOK_ICONS.hidden,
    },
    {
      id: 9,
      name: 'facebook_message_confirm',
      href: PATH.FACEBOOK_MESSAGE_CONFIRM_ORDER,
      icon: FACEBOOK_ICONS.messageConfirm,
    },
    {
      id: 10,
      name: 'facebookManament_assign_product_to_comment_menu',
      href: PATH.FACEBOOK_ASSIGN_PRODUCT_TO_COMMENT,
      icon: FACEBOOK_ICONS.livestreamProduct,
    },
    {
      id: 4,
      name: 'facebookManagement_autoComment',
      href: '/facebook/auto-responses',
      icon: FACEBOOK_ICONS.chat,
    },
    {
      id: 5,
      name: 'facebookManagement_livestreamScript',
      href: '/facebook/livestream-scripts',
      icon: FACEBOOK_ICONS.book,
    },
    {
      id: 6,
      name: 'facebookManagement_autoMess',
      href: '/facebook/auto-messages',
      icon: FACEBOOK_ICONS.mess,
    },
    {
      id: 7,
      name: 'facebookManagement_order_script_post',
      href: PATH.FACEBOOK_ORDER_SCRIPT_POST,
      icon: FACEBOOK_ICONS.scriptPost,
    },
    {
      id: 8,
      name: 'facebookManagement_printerSetup',
      href: '/facebook/printer-settings',
      icon: FACEBOOK_ICONS.printer,
    },
  ],

}
